import React from 'react';
import PropTypes from 'prop-types';

import './chevron_round.scss';

export default function ChevronRound(props) {
  const {
    width, height, right, disabled, dark, onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={`chevron-round ${right && 'chevron-round--right'} ${disabled && 'chevron-round--disabled'} ${dark && 'chevron-round--dark'}`}
    >
      <path
        d="M43 21.9996C43 33.5976 33.598 42.9996 22 42.9996C10.402 42.9996 0.999997 33.5976 0.999994 21.9996C0.999991 10.4017 10.402 0.999643 22 0.99964C33.598 0.999637 43 10.4017 43 21.9996Z"
        stroke="content"
        strokeWidth="2"
      />
      <path
        d="M23 16.9996L18 21.9996L23 26.9996"
        stroke="content"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

ChevronRound.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  right: PropTypes.bool,
  disabled: PropTypes.bool,
  dark: PropTypes.bool,
  onClick: PropTypes.func,
};

ChevronRound.defaultProps = {
  width: '44',
  height: '44',
  right: false,
  disabled: false,
  dark: false,
  onClick: () => {
  },
};
